import { render, staticRenderFns } from "./WbtConfigTableActions.vue?vue&type=template&id=a5e47724&"
import script from "./WbtConfigTableActions.vue?vue&type=script&lang=js&"
export * from "./WbtConfigTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports